import { combineReducers } from 'redux'

import development from './development'

export const reducer = combineReducers({
  development: development.reducer,
})

export default reducer
